/* lv-order-timer v3: "Offer ends in" copy with pulsing red countdown (#d60000).
   Matches the freePacksFade animation from the Maostix PDP "claim ur free pack" text.
   Announcement-bar line + card above the add-to-cart button.
   Luvano counts to the end of November; Maostix resets at visitor-local midnight. */
(() => {
  "use strict";
  if (window.__lvOrderTimer) return;
  window.__lvOrderTimer = 1;

  const NUNITO = "Nunito,system-ui,-apple-system,sans-serif";
  const SITES = {
    baby: { host: "#luvano-pdp-host", bar: ".promo", atc: "#buybox .ctaWrap",
      t: { ink: "#123524", acc: "#745126", hi: "#f5d78e", card: "#fbfdf6", line: "rgba(116,81,38,.30)", text: "#30291f", mute: "#716251", font: NUNITO, r: "14px" } },
    dog: { host: "#luvano-pdp-host", bar: ".promo", atc: "#buybox .ctaWrap",
      t: { ink: "#123524", acc: "#1c4a2e", hi: "#c9e265", card: "#fbfdf6", line: "rgba(28,74,46,.26)", text: "#19231a", mute: "#5a5c4c", font: NUNITO, r: "14px" } },
    cinnamon: { host: "#luvano-pdp-host", bar: ".promo", atc: "#buybox .ctaWrap",
      t: { ink: "#123524", acc: "#865326", hi: "#edcc9b", card: "#fbfdf6", line: "rgba(134,83,38,.28)", text: "#282b25", mute: "#676354", font: NUNITO, r: "14px" } },
    leggings: { host: null, bar: "div.announcement", barInline: true, atc: "#add",
      t: { ink: "#4b1327", acc: "#4b1327", hi: "#ffffff", card: "#ffffff", line: "#ead7dc", text: "#271f22", mute: "#6f5a61", font: '"DM Sans",Arial,sans-serif', r: "10px" } },
    maostix: { host: "#maostix-pdp-host", bar: ".promo", atc: "#buybox .ctaWrap",
      t: { ink: "#123524", acc: "#1c4a2e", hi: "#c9e265", card: "#ffffff", line: "#e6e0cf", text: "#19231a", mute: "#5a5c4c", font: NUNITO, r: "14px" } },
  };
  SITES.maostix_es = { ...SITES.maostix, lang: "es" };
  const TXT = {
    en: { order: "Offer ends in", title: "Offer ends in", u: ["hrs", "min", "sec"],
      aria: (h, m) => `Offer ends in ${h} hours and ${m} minutes.` },
    bm: { order: "Black Month ends in", title: "Black Month", sub: "Ends 30 November", day: "days", u: ["hrs", "min", "sec"],
      aria: (d, h, m) => `Black Month ends in ${d} ${d === 1 ? "day" : "days"}, ${h} ${h === 1 ? "hour" : "hours"} and ${m} ${m === 1 ? "minute" : "minutes"}.` },
    es: { order: "La oferta termina en", title: "La oferta termina en", u: ["hrs", "min", "seg"],
      aria: (h, m) => `La oferta termina en ${h} horas y ${m} minutos.` },
  };
  const BY_HOST = { "luvanobaby.com": "baby", "luvanopets.co": "dog", "luvanosupps.com": "cinnamon", "luvanosport.com": "leggings", "maostix.com": "maostix" };
  const key = window.LV_TIMER_SITE || BY_HOST[location.hostname.replace(/^www\./, "")];
  const S = SITES[key];
  if (!S) return;
  const BM = ["baby", "dog", "cinnamon", "leggings"].includes(key);
  const BM_START = new Date(2026, 10, 1, 0, 0, 0);
  const BM_END = new Date(2026, 11, 1, 0, 0, 0);
  const T = BM ? TXT.bm : TXT[S.lang] || TXT.en;

  const TRUCK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 4h14v11H1z"/><path d="M15 8h4l4 4v3h-8"/><circle cx="5.5" cy="18" r="2"/><circle cx="18.5" cy="18" r="2"/></svg>';
  const CLOCK = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';

  const CSS = `
  @keyframes lvtPulse{0%,100%{opacity:1}50%{opacity:0}}
  .lvt-bar{display:flex;align-items:center;justify-content:center;gap:6px;margin-top:3px;font:700 12.5px/1.25 var(--lvt-font);letter-spacing:0;color:rgba(255,255,255,.9)}
  .lvt-bar.inl{display:inline-flex;margin:0 0 0 8px;vertical-align:middle}
  .lvt-bar svg{opacity:.85;flex:none}
  .lvt-time{font-variant-numeric:tabular-nums;font-weight:900;color:#fff;background:rgba(255,255,255,.18);border-radius:5px;padding:1px 6px;animation:lvtPulse 2.1s ease-in-out infinite}
  .lvt-card{position:relative;display:flex;align-items:center;gap:10px;margin:12px 0 0;padding:10px 12px 13px;background:var(--lvt-card);
    border:1.5px solid var(--lvt-line);border-radius:var(--lvt-r);font-family:var(--lvt-font);color:var(--lvt-text);overflow:hidden;
    box-shadow:0 6px 18px rgba(28,60,32,.06);letter-spacing:0;text-align:left}
  .lvt-ico{flex:none;width:36px;height:36px;border-radius:50%;display:grid;place-items:center;color:var(--lvt-acc);
    background:rgba(0,0,0,.05);background:color-mix(in srgb,var(--lvt-acc) 12%,transparent)}
  .lvt-txt{flex:1;min-width:0}
  .lvt-t1{font-size:14.5px;font-weight:900;line-height:1.2;color:var(--lvt-ink)}
  .lvt-clock{display:flex;align-items:flex-start;gap:3px;flex:none;animation:lvtPulse 2.1s ease-in-out infinite}
  .lvt-d{display:flex;flex-direction:column;align-items:center;gap:3px}
  .lvt-d b{min-width:33px;height:34px;display:grid;place-items:center;border-radius:9px;background:#d60000;color:#fff;
    font:900 17px/1 var(--lvt-font);font-variant-numeric:tabular-nums}
  .lvt-d i{font-style:normal;font:800 8.5px/1 var(--lvt-font);letter-spacing:.08em;text-transform:uppercase;color:var(--lvt-mute)}
  .lvt-sep{font:900 16px/34px var(--lvt-font);color:#d60000}
  .lvt-prog{position:absolute;left:0;right:0;bottom:0;height:3px;background:rgba(0,0,0,.06);background:color-mix(in srgb,var(--lvt-ink) 9%,transparent)}
  .lvt-prog span{display:block;height:100%;width:100%;background:var(--lvt-acc);transform-origin:left;transition:transform 1s linear}
  @media (prefers-reduced-motion:reduce){.lvt-prog span{transition:none}.lvt-time,.lvt-clock{animation:none}}`;

  const BM_CSS = `
  .lvt-blackmonth .lvt-t2{font-size:12px;font-weight:700;line-height:1.3;color:var(--lvt-mute);margin-top:2px}
  .lvt-blackmonth.lvt-bar .lvt-time{white-space:nowrap}
  .lvt-blackmonth.lvt-bar.inl{flex-wrap:wrap;max-width:100%}
  .lvt-blackmonth .lvt-stock{font-size:12px;font-weight:700;line-height:1.3;color:var(--lvt-mute);margin-top:3px}
  .lvt-blackmonth .lvt-stock-dot{display:inline-block;width:7px;height:7px;border-radius:50%;background:#d60000;margin-right:5px;vertical-align:middle;animation:lvtPulse 2s ease-in-out infinite}
  @media(max-width:440px){.lvt-blackmonth.lvt-card{flex-wrap:wrap}.lvt-blackmonth .lvt-clock{flex:0 0 100%;box-sizing:border-box;padding-left:46px}}
  @media(prefers-reduced-motion:reduce){.lvt-blackmonth .lvt-stock-dot{animation:none}}
  ` + (key === "leggings" ? `
  html[data-pdp="sculpt"] .lvt-blackmonth.lvt-bar,html[data-pdp="smooth"] .lvt-blackmonth.lvt-bar{display:inline-flex!important}
  html[data-pdp="sculpt"] .lvt-blackmonth.lvt-card,html[data-pdp="smooth"] .lvt-blackmonth.lvt-card{display:flex!important}
  ` : "");

  const pad = (n) => String(n).padStart(2, "0");

  function state() {
    const now = new Date();
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const left = Math.max(0, Math.floor(((BM ? BM_END : midnight) - now) / 1000));
    const withinDay = BM ? left % 86400 : left;
    return {
      left, d: pad(Math.floor(left / 86400)),
      h: pad(Math.floor(withinDay / 3600)), m: pad(Math.floor((withinDay % 3600) / 60)), s: pad(withinDay % 60),
      frac: BM ? Math.min(1, left / ((BM_END - BM_START) / 1000)) : left / 86400,
    };
  }

  const styles = new Map();
  let bar = null, card = null;
  function build() {
    bar = document.createElement(S.barInline ? "span" : "div");
    bar.className = "lvt-bar" + (S.barInline ? " inl" : "") + (BM ? " lvt-blackmonth" : "");
    bar.innerHTML = `${CLOCK}<span>${T.order} <span class="lvt-time" data-k="hms"></span></span>`;
    card = document.createElement("div");
    card.className = "lvt-card" + (BM ? " lvt-blackmonth" : "");
    card.setAttribute("role", "timer");
    card.setAttribute("aria-live", "off");
    const sub = BM ? `<div class="lvt-t2">${T.sub}</div>` : "";
    const stock = key === "leggings" ? `<div class="lvt-stock"><span class="lvt-stock-dot" aria-hidden="true"></span>Low stock</div>` : "";
    const day = BM ? `<span class="lvt-d"><b data-k="d"></b><i>${T.day}</i></span><span class="lvt-sep">:</span>` : "";
    card.innerHTML = `<div class="lvt-ico">${TRUCK}</div>
      <div class="lvt-txt"><div class="lvt-t1">${T.title}</div>${sub}${stock}</div>
      <div class="lvt-clock" aria-hidden="true">
        ${day}<span class="lvt-d"><b data-k="h"></b><i>${T.u[0]}</i></span><span class="lvt-sep">:</span>
        <span class="lvt-d"><b data-k="m"></b><i>${T.u[1]}</i></span><span class="lvt-sep">:</span>
        <span class="lvt-d"><b data-k="s"></b><i>${T.u[2]}</i></span></div>
      <div class="lvt-prog"><span></span></div>`;
  }
  function place() {
    const root = S.host ? document.querySelector(S.host)?.shadowRoot : document;
    if (!root) return false;
    const barEl = root.querySelector(S.bar), atcEl = root.querySelector(S.atc);
    if (!barEl || !atcEl) return false;
    let st = styles.get(root);
    if (!st || !st.isConnected) {
      st = document.createElement("style");
      st.textContent = `:host,:root{--lvt-ink:${S.t.ink};--lvt-acc:${S.t.acc};--lvt-hi:${S.t.hi};--lvt-card:${S.t.card};--lvt-line:${S.t.line};` +
        `--lvt-text:${S.t.text};--lvt-mute:${S.t.mute};--lvt-font:${S.t.font};--lvt-r:${S.t.r}}` + CSS + (BM ? BM_CSS : "");
      (root === document ? document.head : root).appendChild(st);
      styles.set(root, st);
    }
    if (bar.parentNode !== barEl) barEl.appendChild(bar);
    if (card.previousElementSibling !== atcEl) atcEl.parentNode.insertBefore(card, atcEl.nextSibling);
    return true;
  }

  function render() {
    const v = state();
    if (BM && !v.left) { if (bar.isConnected) bar.remove(); if (card.isConnected) card.remove(); return false; }
    if (key === "leggings") {
      const add = document.querySelector("#add");
      const stock = card.querySelector(".lvt-stock");
      if (stock) stock.hidden = !!(add?.disabled && /^sold out$/i.test(add.textContent.trim()));
    }
    for (const el of [bar, card]) {
      el.querySelectorAll('[data-k="hms"]').forEach((n) => (n.textContent = (BM ? `${v.d}\u00a0${T.day}\u00a0` : "") + `${v.h}:${v.m}:${v.s}`));
      if (BM) el.querySelectorAll('[data-k="d"]').forEach((n) => (n.textContent = v.d));
      el.querySelectorAll('[data-k="h"]').forEach((n) => (n.textContent = v.h));
      el.querySelectorAll('[data-k="m"]').forEach((n) => (n.textContent = v.m));
      el.querySelectorAll('[data-k="s"]').forEach((n) => (n.textContent = v.s));
    }
    card.querySelector(".lvt-prog span").style.transform = `scaleX(${v.frac.toFixed(4)})`;
    card.setAttribute("aria-label", BM ? T.aria(+v.d, +v.h, +v.m) : T.aria(+v.h, +v.m));
    return true;
  }

  function start() {
    const tick = () => { if (!render()) return; place(); setTimeout(tick, 1000 - (Date.now() % 1000) + 5); };
    setTimeout(tick, 1000 - (Date.now() % 1000) + 5);
  }

  build();
  let tries = 0;
  (function wait() { if (!render()) return; if (place()) return start(); if (++tries < 160) setTimeout(wait, 250); })();
})();
